import { Loader2, LoaderCircle } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * Displays a full-screen, centered loading spinner.
 * Uses the `Loader` icon from lucide-react with a spinning animation.
 */
export const CenteredLoader = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <LoaderCircle className="animate-spin text-blue-500 w-12 h-12" />
    </div>
  );
};

/**
 * A spinner centred in a block of its own, for a panel or a page section that
 * has nothing to show yet. Six screens wrote this out; the height is the only
 * thing that ever differed, so it is the prop.
 *
 * `CenteredLoader` above is the whole-viewport case and stays as it is.
 */
export const CenteredSpinner = ({ className = "h-48", iconClassName = "h-6 w-6" }) => (
  <div className={cn("flex items-center justify-center", className)}>
    <Loader2 className={cn("animate-spin text-text-secondary", iconClassName)} />
  </div>
);
